import $ from 'jquery';
import constants from 'Constants.js';
import Immutable from 'immutable';
import listService from 'ListService'
import _ from 'lodash';
import { View } from 'backbone';
import Template from 'report/properties/main/data-aggregate.ejs'

class MainDataAggregateView extends View {


    initialize( opts ) {

        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;
        this.config = opts.config || {};

        this.events = {

            "change #columnAggregate"          : 'updateSelectAttributes'
            
        };

       //console.log(this.model.attributes);

        //this.listenTo(this.model, 'change', this.render);
        return this;
    }

        
    setColumnSpecificToGridData( propName, propVal ){
        var gridData = this.model.get('gridData');
        var rowid = this.model.get('rowid');
        if(!rowid){ rowid = 0; }

        var myRow = gridData[rowid];
        myRow[propName] = propVal;
        gridData[rowid] = myRow;
        this.model.set('gridData', gridData);
    }

    updateSelectAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;

        if (ev.currentTarget.className  === 'columnSpecific'){
            console.log('updateSelectAttributes columnSpecific');
            this.setColumnSpecificToGridData( propName, propVal )

            var rowid = this.model.get('rowid');
            
            this.updateColumnProperty(rowid, propName, propVal);
            if (propName === 'aggregation') {
                this.updateReportingMetaDataColumn(rowid, propName, propVal);
            }
        }

        this.model.set( propName, propVal );
    }

    updateColumnProperty(rowid, propName, propVal) {
        const columns = this.model.get('Columns');

        columns.Column[rowid].Properties[propName] = propVal;
    }

    updateReportingMetaDataColumn(rowid, propName, propVal) {
        const md = listService.getReportingMetaData(this.model.get('id'));

        if (md.Columns) {
            _.forEach(md.Columns, (col) => {
                if (col.id.toString() === rowid.toString()) {
                    col[propName] = propVal;
                }
            });
        }
    }

    render() {
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        $("#columnAggregate option[value='" + this.model.get('columnAggregate') + "']").prop('selected', true);

        this.delegateEvents();
        return this;
    }
}

export default MainDataAggregateView;
